import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { readCiRelationType, readCiRelationTypes } from "../services/ciRelationTypesApi";

export function useCiRelationTypeQuery(publicId, isOpen) {
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["ci_relation_type", publicId],
    queryFn: () => readCiRelationType(publicId),
    enabled: isOpen && !!publicId,
    gcTime: 0,
    onError: (error) => {
      toast.error(error.message || t("item.messages.fetchError"));
    },
  });
}

export function useCiRelationTypesQuery() {
  return useQuery({
    queryKey: ["ci_relation_types"],
    queryFn: () => readCiRelationTypes(),
  });
}
